<script lang="ts">
	const { data } = $props();

	const standingsRow = $derived(
		data.standings.data.rows.find((row) => row.id === data.team.data.teamData.id)!!
	);
</script>

{#snippet stat(number: number, text: string)}
	<div class="flex min-w-0 flex-col items-center gap-2 text-center">
		<div
			class="text-base-content text-4xl font-black tracking-wide tabular-nums sm:text-6xl xl:text-7xl"
		>
			{number}
		</div>
		<div
			class="w-full text-sm font-bold wrap-break-word hyphens-auto uppercase sm:text-base xl:text-lg"
		>
			{text}
		</div>
	</div>
{/snippet}

<div class="bg-base-100 flex min-w-0 flex-col gap-3 p-4 sm:p-6">
	<div class="grid grid-cols-2 gap-x-3 gap-y-6 md:grid-cols-4">
		{@render stat(data.team.data.teamStats.gamesPlayed, 'Spiele')}
		{@render stat(standingsRow.gamesWon + standingsRow.gamesWonInOt, 'Gewonnen')}
		{@render stat(standingsRow.gamesLost + standingsRow.gamesLostInOt, 'Verloren')}
		{@render stat(standingsRow.gamesTied, 'Unentschieden')}
		{@render stat(data.team.data.teamRoster.length, 'Spieler')}
		{@render stat(standingsRow.goalsFor, 'Tore')}
		{@render stat(data.team.data.teamStats.penaltyMinutes, 'Strafminuten')}
		{@render stat(standingsRow.points, 'Punkte')}
	</div>
</div>
